exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".nicklist {\n  right: 0px;\n  top: 50px;\n  width: 12%;\n  min-width: 90px;\n  max-width: 180px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-top: 25px;\n  padding-left: 0.5vw;\n  border-left-color: lightgray;\n  border-left-width: 1px;\n  border-left-style: solid; }\n\n.nicklist-entry {\n  padding: 0.5vw;\n  padding-bottom: 0.3vw;\n  padding-top: 0.8vw;\n  font-size: 17px;\n  font-size: 1.6vw;\n  cursor: pointer; }\n  @media (max-width: 937.5px) {\n    .nicklist-entry {\n      font-size: 15px; } }\n  @media (min-width: 1375px) {\n    .nicklist-entry {\n      font-size: 22px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/views/nicklist/nicklist.scss
// module id = 1010
// module chunks = 0